import http, { handleApiResponse, checkResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import { AccItemParamRowDTO, BokParamType, Lookup, SaveAccItemParamRow } from "../models/AccItemParamRow";

export default class AccItemParamApi {
    static getParamTypes(): Promise<BokParamType[]> {
        return http.get<ApiResponse<BokParamType[]>>(`accounting/acc-item-param/param-types`).then(handleApiResponse);
    }

    static getRows(): Promise<AccItemParamRowDTO[]> {
        return http.get<ApiResponse<AccItemParamRowDTO[]>>(`accounting/acc-item-param`).then(handleApiResponse);
    }

    static getBrands(): Promise<Lookup[]> {
        return http.get<ApiResponse<Lookup[]>>(`accounting/acc-item-param/brands`).then(handleApiResponse);
    }

    static getDepots(): Promise<Lookup[]> {
        return http.get<ApiResponse<Lookup[]>>(`depot`).then(handleApiResponse);
    }

    static getStatGroups(): Promise<Lookup[]> {
        return http.get<ApiResponse<Lookup[]>>(`accounting/acc-item-param/stat-groups`).then(handleApiResponse);
    }

    static getDivisionItems(): Promise<Lookup[]> {
        return http.get<ApiResponse<Lookup[]>>(`division-item`).then(handleApiResponse);
    }

    static saveRow(row: SaveAccItemParamRow): Promise<boolean> {
        return http.post(`accounting/acc-item-param`, row).then(checkResponse);
    }

    static removeRow(brand: number, depot: number, statGroup: number, divItem: number): Promise<boolean> {
        return http
            .delete(`accounting/acc-item-param?brand=${brand}&depot=${depot}&statGroup=${statGroup}&divItem=${divItem}`)
            .then(checkResponse);
    }
}
